import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { categoryLabel, formatPublishedDate, resolveImageUrl } from "@/lib/journal";
import PresetHero from "./PresetHero";

export default function PostCard({ post, testId }) {
  const img = resolveImageUrl(post.featured_image_url);
  const hasHero = img || post.featured_preset;
  return (
    <Link
      to={`/journal/${post.slug}`}
      className="card-paper block p-0 overflow-hidden group"
      data-testid={testId}
    >
      {hasHero && (
        <div className="aspect-[16/9] overflow-hidden bg-paper">
          {img ? (
            <img
              src={img}
              alt={post.title}
              className="w-full h-full object-cover group-hover:scale-[1.02] transition-transform duration-500"
              loading="lazy"
            />
          ) : (
            <PresetHero presetId={post.featured_preset} title={post.title} showCaption={false} />
          )}
        </div>
      )}
      <div className="p-6 md:p-7">
        <div className="flex items-center justify-between text-[12px] mb-3 gap-2">
          <span className="chip whitespace-nowrap">{categoryLabel(post.category)}</span>
          <span className="num text-ink-soft whitespace-nowrap">
            {formatPublishedDate(post.published_at)}
          </span>
        </div>
        <h3 className="font-display text-xl md:text-[22px] text-ink leading-snug">
          {post.title}
        </h3>
        {post.excerpt && (
          <p className="text-[14px] text-ink-soft mt-2 leading-relaxed line-clamp-3">
            {post.excerpt}
          </p>
        )}
        <div className="mt-4 inline-flex items-center gap-1.5 text-[13px] text-brass-deep">
          Read <ArrowUpRight size={14} />
        </div>
      </div>
    </Link>
  );
}
